import moment from "moment";
import loginedApi from "../apis";
import authHeader from "./auth-header";
import { check_consultation } from "./MicrositeAction";
import {
  DASHBOARD_DATA_PATIENT,
  FETCH_COUNTRYDATA,
  DASHBOARD_DATA_DOCTOR,
} from "./type";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

const publicIp = require("public-ip");
const { detect } = require("detect-browser");
const browser = detect();
let IP = publicIp.v4();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;

let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const fetchUpcomingAppointmentList = (patientId) => async (dispatch) => {
  let today = moment(new Date()).format("DD-MMM-YYYY");

  console.log("Inside fetch_dashboardData");
  let resp = await loginedApi.post("getcountrycode", {
    token: hashcode.toString(),
    version: "2.0",
    data: { browserTimeZone: "GMT%2B05:30" },
    requestType: 1058,
  });
  const doctorscountrycode = resp.data.data;

  let data = {
    patientId: patientId,
    browserTimeZone: `GMT${formatTime}`,
    dayOfAppointment: moment(new Date()).format("DD-MMM-yyy"),
    appointmentNavigation: "",
    todayRate: "74.45000",
    currency: doctorscountrycode.currency,
    accessCountry: doctorscountrycode.Country,

    Ipaddress: doctorscountrycode.Ipaddress,
    useragent: userAgent,
    Browser: browser.name + " " + browser.version,
    Os: platform,
  };

  const response = await loginedApi.post(
    "upcomingappointments",
    {
      requestType: "1065",
      version: "2.0",
      token: hashcode.toString(),
      data,
    },
    { headers: authHeader() }
  );
  console.log("Printin them: ", response.data.data.data);

  if (response.status === 200) {
    dispatch({
      type: DASHBOARD_DATA_PATIENT,
      payload: response.data.data.data,
    });
  }

  return response.data.data;
};

export const fetchAppointmentDetails =
  (userId, appointmentId, userType) => async (dispatch) => {
    try {
      const resp = await loginedApi.post("getcountrycode", {
        token: hashcode.toString(),
        version: "2.0",
        data: { browserTimeZone: "GMT%2B05:30" },
        requestType: 1058,
      });

      const doctorscountrycode = resp.data.data;

      let data = {
        userId: userId,
        appointmentId: appointmentId,
        browserTimeZone: `GMT${formatTime}`,
        todayRate: "74.45000",
        userType: userType,
        currency: doctorscountrycode.currency,
        accessCountry: doctorscountrycode.Country,
        Ipaddress: doctorscountrycode.Ipaddress,
        useragent: userAgent,
        Browser: browser.name + " " + browser.version,
        Os: platform,
      };

      const response = await loginedApi.post(
        "appointments",
        {
          requestType: "77",
          version: "2.0",
          token: hashcode.toString(),
          data,
        },
        { headers: authHeader() }
      );

      if (response.status === 200) {
        dispatch({
          type: DASHBOARD_DATA_PATIENT,
          payload: response.data.data.data,
        });
      }

      return response.data.data;
    } catch (error) {
      console.error("Error fetching  appointments:", error);
      throw error;
    }
  };

export const fetchPastAppointments =
  (patientId, offset, selectedDate, searchType) => async (dispatch) => {


   console.log(patientId, offset, selectedDate, searchType)
   console.log("formatted", convertDateToString(selectedDate));

    try {
      const resp = await loginedApi.post("getcountrycode", {
        token: hashcode.toString(),
        version: "2.0",
        data: { browserTimeZone: "GMT%2B05:30" },
        requestType: 1058,
      });

      const doctorscountrycode = resp.data.data;

      let data = {
        patientId: patientId,

        browserTimeZone: `GMT${formatTime}`,
        todayRate: "74.45000",
        offset: offset,
        appointmentNavigation: "",
        dayOfAppointment: selectedDate
          ? moment(selectedDate).format("DD-MMM-yyy")
          : moment(new Date()).format("DD-MMM-yyy"),
        Searchdate: selectedDate!=undefined ? selectedDate: moment(new Date()).format("DD-MMM-yyy"),
          
          searchType: searchType,
          currency: doctorscountrycode.currency,
        accessCountry: doctorscountrycode.Country,
        Ipaddress: doctorscountrycode.Ipaddress,
        useragent: userAgent,
        Browser: browser.name + " " + browser.version,
        Os: platform,
      };
     

      const response = await loginedApi.post(
        "pastappointments",
        {
          requestType: "65",
          version: "2.0",
          token: hashcode.toString(),
          data,
        },
        { headers: authHeader() }
      );

      if (response.status === 200) {
        dispatch({
          type: DASHBOARD_DATA_PATIENT,
          payload: response.data.data.data,
        });
      }

      return response.data.data;
    } catch (error) {
      console.error("Error fetching past appointments:", error);
      throw error;
    }
  };

export const fetch_dashboardData =
  (patientId, email, phone) => async (dispatch) => {
    let today = moment(new Date()).format("DD-MMM-YYYY");

    console.log("Inside fetch_dashboardData");
    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: "GMT%2B05:30" },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    let data = {
      patientId: patientId,
      patientEmail: email,
      patientMobile: phone,
      browserTimeZone: `GMT${formatTime}`,
      dayOfAppointment: moment(new Date()).format("DD-MMM-yyy"),
      appointmentNavigation: "",
      todayRate: "74.45000",
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,

      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      Os: platform,
    };

    const response = await loginedApi.post(
      "profile",
      {
        requestType: "51",
        token: hashcode.toString(),
        version: "2.0",
        data,
      },
      { headers: authHeader() }
    );
    console.log("Finished fetching patient dashboard data");
    console.log("Printin them: ", response.data.data.data);

    if (response.status === 200) {
      dispatch({
        type: DASHBOARD_DATA_PATIENT,
        payload: response.data.data.data,
      });
    }

    return response.data.data;
  };
// Recent activities API integration
export const fetch_recentactivities =
  (patientId, email, phone) => async (dispatch) => {
    let today = moment(new Date()).format("DD-MMM-YYYY");

    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: "GMT%2B05:30" },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    let data = {
      patientId: patientId,
      patientEmail: email,
      patientMobile: phone,
      browserTimeZone: `GMT${formatTime}`,
      todayRate: "74.45000",
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      Os: platform,
    };

    const response = await loginedApi.post(
      "getrecentactivities",
      {
        requestType: "1039",
        version: "2.0",
        token: hashcode.toString(),
        data,
      },
      { headers: authHeader() }
    );

    // console.log("recent activities----",response)

    if (response.status === 200) {
      // dispatch({ type: DASHBOARD_DATA_PATIENT, payload: response.data.data.data });
    }

    return response.data.data;
  };

//patients daywise appointment
export const getDaywiseAppointment =
  (patientId, email, phone) => async (dispatch) => {
    let today = moment(new Date()).format("DD-MMM-YYYY");

    console.log("Inside fetch_dashboardData");
    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: "GMT%2B05:30" },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    let data = {
      patientId: patientId,
      patientEmail: email,
      patientMobile: phone,
      browserTimeZone: `GMT${formatTime}`,
      dayOfAppointment: moment(new Date()).format("DD-MMM-yyy"),
      appointmentNavigation: "",
      todayRate: "74.45000",
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,

      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      Os: platform,
    };

    console.log("CAlling request data: 65");

    const response = await loginedApi.post(
      "appointments",
      {
        requestType: "65",
        token: hashcode.toString(),
        version: "2.0",
        data,
      },
      { headers: authHeader() }
    );
    console.log("Finished fetching patient dashboard data");
    console.log("Printin them: ", response.data.data.data);

    if (response.status === 200) {
      dispatch({
        type: DASHBOARD_DATA_PATIENT,
        payload: response.data.data.data,
      });
    }

    return response.data.data;
  };

//patients daywise appointment
export const getappointmentrequest =
  (patientId, email, phone) => async (dispatch) => {
    let today = moment(new Date()).format("DD-MMM-YYYY");

    console.log("Inside fetch_dashboardData");
    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: "GMT%2B05:30" },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    let data = {
      patientId: patientId,
      patientEmail: email,
      patientMobile: phone,
      browserTimeZone: `GMT${formatTime}`,
      dayOfAppointment: moment(new Date()).format("DD-MMM-yyy"),
      appointmentNavigation: "",
      todayRate: "74.45000",
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,

      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      Os: platform,
    };

    console.log("CAlling request data: 88");

    const response = await loginedApi.post(
      "getuserappointmentrequests",
      {
        requestType: "88",
        version: "2.0",
        token: hashcode.toString(),
        data,
      },
      { headers: authHeader() }
    );
    console.log("Finished fetching patient dashboard data");
    console.log("Printin them: ", response.data.data.data);

    if (response.status === 200) {
      dispatch({
        type: DASHBOARD_DATA_PATIENT,
        payload: response.data.data.data,
      });
    }

    return response.data.data;
  };

export const uploadReports =
  ({ formData, userData, dashboardData }) =>
  async (dispatch) => {
    console.log({ formData, userData, dashboardData });

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const response = await loginedApi.post(
      "updatereports",
      {
        body: formData,
      },
      config
    );

    console.log("File upload result==>", response);

    if (response.status === 200) {
      dispatch(check_consultation(userData, dashboardData));
    }
  };

export const getCountryData = () => async (dispatch) => {
  const res = await loginedApi.post("getcountrycode", {
    token: hashcode.toString(),
    version: "2.0",
    data: { browserTimeZone: "GMT%2B05:30" },
    requestType: 1058,
  });

  if (res.status === 200) {
    dispatch({ type: FETCH_COUNTRYDATA, payload: res.data.data });
  }
};

export const findConsultationForNow =
  (userType, UserId) => async (dispatch) => {
    console.log("Calling..............findConsultationForNow..............");

    let params = {
      requestType: "201",
      version: "2.0",
      token: hashcode.toString(),
      data: {
        browserTimeZone: `GMT${formatTime}`,
        todayRate: "",
        userId: UserId,
        userType: userType,
      },
    };

    const response = await loginedApi.post("consultation", params, {
      headers: authHeader(),
    });
    // dispatch({ type: FETCH_CONSULTATION, payload: response.data.data });
   

    return response.data.data;
  };


  export const convertDateToString = (_date) => {

    if (_date) {
  
     return moment(_date).format("DD-MMM-YYYY"); 
  
    }
  
  }